document.addEventListener('DOMContentLoaded', function () {
  // Reveal letra-por-letra só no desktop — no mobile o layout empilhado
  // do tema (foto em cima, conteúdo embaixo) fazia essa animação bugar.
  // Abaixo de 768px o botão/ícone ainda são adicionados, mas sem o
  // SplitType nem o reveal por caractere.
  var isDesktop = window.matchMedia('(min-width: 768px)').matches;

  var titles = document.querySelectorAll('.miya-hero .slide__block-title');
  if (!titles.length) return;

  if (!isDesktop || typeof SplitType === 'undefined') {
    // Ícone do botão continua sendo adicionado independente do reveal.
    document.querySelectorAll('.miya-hero a.sf__btn-white').forEach(function (btn) {
      if (btn.querySelector('.mk-btn-icon')) return;
      btn.insertAdjacentHTML(
        'beforeend',
        '<svg class="mk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>'
      );
    });
    return;
  }

  titles.forEach(function (title) {
    new SplitType(title, { types: 'chars, words' });
  });

  // Ícone de seta no botão (SVG inline, sem depender de lib de ícones —
  // o tema não carrega lucide/iconify globalmente).
  document.querySelectorAll('.miya-hero a.sf__btn-white').forEach(function (btn) {
    if (btn.querySelector('.mk-btn-icon')) return;
    btn.insertAdjacentHTML(
      'beforeend',
      '<svg class="mk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>'
    );
  });

  function animateSlide(slide) {
    if (slide.dataset.mkAnimated === '1') return; // já animou esse ciclo
    slide.dataset.mkAnimated = '1';

    var chars = slide.querySelectorAll('.char');
    chars.forEach(function (char, i) {
      char.style.transitionDelay = (i * 18) + 'ms';
      char.classList.remove('is-in');
      void char.offsetWidth; // força reflow pra reiniciar a transição
      char.classList.add('is-in');
    });

    // Descrição e botão entram com uma leve sobreposição sobre o fim
    // do stagger das letras, em vez de aparecerem juntos com o título.
    var charsTotalDuration = chars.length ? (chars.length - 1) * 18 + 800 : 0;
    var followDelay = Math.max(300, charsTotalDuration - 600);

    var desc = slide.querySelector('.slide__block-description');
    var btn = slide.querySelector('.slide__block-link');
    [desc, btn].forEach(function (el) {
      if (!el) return;
      el.style.transitionDelay = followDelay + 'ms';
      el.classList.remove('is-in');
      void el.offsetWidth;
      el.classList.add('is-in');
    });

    // Depois que o botão termina de entrar: tira o delay e volta a
    // duração do transform pro padrão rápido (0.3s), senão o hover
    // herdaria os 0.9s usados só pra animação de entrada.
    if (btn) {
      btn.addEventListener('transitionend', function resetTransition(e) {
        if (e.propertyName === 'opacity') {
          btn.style.transitionDelay = '0ms';
          btn.style.transitionDuration = '0.3s, 0.3s, 0.3s';
          btn.removeEventListener('transitionend', resetTransition);
        }
      });
    }
  }

  // Observer único no container pai (em vez de um por slide): continua
  // funcionando mesmo se o componente <m-slideshow> reorganizar ou
  // reconstruir os nós dos slides internamente durante o autoplay.
  var wrapper = document.querySelector('.miya-hero .swiper-wrapper')
    || document.querySelector('.miya-hero .swiper-container')
    || document.querySelector('.miya-hero');

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      var el = m.target;
      if (!el.classList || !el.classList.contains('swiper-slide')) return;
      if (el.classList.contains('swiper-slide-active')) {
        animateSlide(el);
      } else {
        delete el.dataset.mkAnimated; // libera pra animar de novo quando voltar a ficar ativo
      }
    });
  });
  observer.observe(wrapper, { attributes: true, attributeFilter: ['class'], subtree: true });

  var firstActive = document.querySelector('.miya-hero .swiper-slide-active');
  if (firstActive) animateSlide(firstActive);
});
